module.exports = __webpack_public_path__ + "img/ico3.dba432f2.png";